import { useContext } from 'react';

import { AutoshipPercentageContext } from '../providers';

export const useAutoshipPercentage = () => {
    const context = useContext(AutoshipPercentageContext);

    if (context === undefined || context === null) {
        throw new Error('useAutoshipPercentage must be used within a AutoshipPercentageContext');
    }

    return context;
};
